module.exports = __webpack_public_path__ + "media/images/National_Football_League_logo-b626064d.svg";